import React from 'react';
import Skeleton from '../Skeleton/Skeleton';
import './DailyStatsSkeleton.scss';

const DailyStatsSkeleton = () => {
  return (
    <div className="daily-stats-skeleton">
      <div className="daily-stats-skeleton__card">
        <div className="daily-stats-skeleton__icon">
          <Skeleton width="24px" height="24px" variant="circular" />
        </div>
        <div className="daily-stats-skeleton__content">
          <div className="daily-stats-skeleton__number">
            <Skeleton width="60px" height="24px" variant="text" />
          </div>
          <div className="daily-stats-skeleton__label">
            <Skeleton width="120px" height="16px" variant="text" />
          </div>
        </div>
      </div>
      
      <div className="daily-stats-skeleton__card">
        <div className="daily-stats-skeleton__icon daily-stats-skeleton__icon--progress">
          <div className="daily-stats-skeleton__progress-circle">
            <Skeleton width="60px" height="60px" variant="circular" />
          </div>
        </div>
        <div className="daily-stats-skeleton__content">
          <div className="daily-stats-skeleton__number">
            <Skeleton width="40px" height="24px" variant="text" />
          </div>
          <div className="daily-stats-skeleton__label">
            <Skeleton width="80px" height="16px" variant="text" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyStatsSkeleton;